import React, { Component } from 'react';
import { Image, ButtonToolbar, Button } from 'react-bootstrap';
import { Translate, Localize } from 'react-redux-i18n';

class PriceAdjustment extends Component {
  constructor() {
    super();
    this.state = {
      URL: ['/img/report/Price_Adjustment_Page_1.png', '/img/report/Price_Adjustment_Page_2.png', '/img/report/Price_Adjustment_Page_3.png'],
      index: 0
    }
  }

  prev() {
    let index = this.state.index
    index = (index > 0) ? index-1:index
    this.setState({index})
  }

  next() {
    let index = this.state.index
    index = (index < this.state.URL.length-1) ? index+1:index
    this.setState({index})
  }

  render() {
    return (
      <div>
        <ButtonToolbar>
          <Button onClick={()=>{this.prev()}}><Translate value="previous" /></Button>
          <Button onClick={()=>{this.next()}}><Translate value="next" /></Button>
        </ButtonToolbar>
        <img src={this.state.URL[this.state.index]} thumbnail/>
      </div>
    )
  }
}

class ProductConvert extends Component {
  constructor() {
    super();
    this.state = {
      URL: ['/img/report/Product_Convert_Page_1.png', '/img/report/Product_Convert_Page_2.png', '/img/report/Product_Convert_Page_3.png'],
      index: 0
    }
  }

  prev() {
    let index = this.state.index
    index = (index > 0) ? index-1:index
    this.setState({index})
  }

  next() {
    let index = this.state.index
    index = (index < this.state.URL.length-1) ? index+1:index
    this.setState({index})
  }

  render() {
    return (
      <div>
        <ButtonToolbar>
          <Button onClick={()=>{this.prev()}}><Translate value="previous" /></Button>
          <Button onClick={()=>{this.next()}}><Translate value="next" /></Button>
        </ButtonToolbar>
        <img src={this.state.URL[this.state.index]}/>
      </div>
    )
  }
}

class PurchasePivot extends Component {
  constructor() {
    super();
    this.state = {
      URL: ['/img/report/Purchase_Pivot_Chart_1.png', '/img/report/Purchase_Pivot_Chart_2.png'],
      index: 0
    }
  }

  prev() {
    let index = this.state.index
    index = (index > 0) ? index-1:index
    this.setState({index})
  }

  next() {
    let index = this.state.index
    index = (index < this.state.URL.length-1) ? index+1:index
    this.setState({index})
  }

  render() {
    return (
      <div>
        <ButtonToolbar>
          <Button onClick={()=>{this.prev()}}><Translate value="previous" /></Button>
          <Button onClick={()=>{this.next()}}><Translate value="next" /></Button>
        </ButtonToolbar>
        <img src={this.state.URL[this.state.index]} thumbnail/>
      </div>
    )
  }
}

class PurchaseReference extends Component {
  constructor() {
    super();
    this.state = {
      URL: ['/img/report/Purchase_Reference_Guide_1.png', '/img/report/Purchase_Reference_Guide_2.png'],
      index: 0
    }
  }

  prev() {
    let index = this.state.index
    index = (index > 0) ? index-1:index
    this.setState({index})
  }

  next() {
    let index = this.state.index
    index = (index < this.state.URL.length-1) ? index+1:index
    this.setState({index})
  }

  render() {
    return (
      <div>
        <ButtonToolbar>
          <Button onClick={()=>{this.prev()}}><Translate value="previous" /></Button>
          <Button onClick={()=>{this.next()}}><Translate value="next" /></Button>
        </ButtonToolbar>
        <img src={this.state.URL[this.state.index]} thumbnail/>
      </div>
    )
  }
}

class PurchasePerformance extends Component {
  constructor() {
    super();
    this.state = {
      URL: ['/img/report/Purchasing _Performance_1.png', '/img/report/Purchasing _Performance_2.png'],
      index: 0
    }
  }

  prev() {
    let index = this.state.index
    index = (index > 0) ? index-1:index
    this.setState({index})
  }

  next() {
    let index = this.state.index
    index = (index < this.state.URL.length-1) ? index+1:index
    this.setState({index})
  }

  render() {
    return (
      <div>
        <ButtonToolbar>
          <Button onClick={()=>{this.prev()}}><Translate value="previous" /></Button>
          <Button onClick={()=>{this.next()}}><Translate value="next" /></Button>
        </ButtonToolbar>
        <img src={this.state.URL[this.state.index]} thumbnail/>
      </div>
    )
  }
}

class SalesPerformance extends Component {
  constructor() {
    super();
    this.state = {
      URL: ['/img/report/Sales_Performance.png'],
      index: 0
    }
  }

  prev() {
    let index = this.state.index
    index = (index > 0) ? index-1:index
    this.setState({index})
  }

  next() {
    let index = this.state.index
    index = (index < this.state.URL.length-1) ? index+1:index
    this.setState({index})
  }

  render() {
    return (
      <div>
        <ButtonToolbar>
          <Button onClick={()=>{this.prev()}}><Translate value="previous" /></Button>
          <Button onClick={()=>{this.next()}}><Translate value="next" /></Button>
        </ButtonToolbar>
        <img src={this.state.URL[this.state.index]} thumbnail/>
      </div>
    )
  }
}

class POSPicture extends Component {
  constructor() {
    super();
    this.state = {
      URL: ['/img/report/POSv2.png'],
      index: 0
    }
  }

  prev() {
    let index = this.state.index
    index = (index > 0) ? index-1:index
    this.setState({index})
  }

  next() {
    let index = this.state.index
    index = (index < this.state.URL.length-1) ? index+1:index
    this.setState({index})
  }

  render() {
    return (
      <div>
        <ButtonToolbar>
          <Button onClick={()=>{this.prev()}}><Translate value="previous" /></Button>
          <Button onClick={()=>{this.next()}}><Translate value="next" /></Button>
        </ButtonToolbar>
        <img src={this.state.URL[this.state.index]} height='665' width='1020' thumbnail/>
      </div>
    )
  }
}

export { PriceAdjustment, ProductConvert, PurchasePivot, PurchaseReference,
  PurchasePerformance, SalesPerformance, POSPicture };



// WEBPACK FOOTER //
// ./master/jsx/components/Report/report.jsx